import { useCallback, useEffect } from 'react';
import Notification from './Notification';

import { useNotificationStore } from '@/stores/notificationstore';
import { NotificationMessage } from '@/types';

export function Notifications() {
  const notificationMessages = useNotificationStore((state) => state.notificationMessages);
  const shift = useNotificationStore((state) => state.shift);

  const close = useCallback(
    (notification?: NotificationMessage) => {
      const currentNotification = useNotificationStore.getState().notificationMessages[0];
      const isCurrentNotification = !notification || currentNotification === notification;
      if (!currentNotification || !isCurrentNotification) return;

      currentNotification.onClose?.();
      shift();
    },
    [shift]
  );

  const currentNotification = notificationMessages[0];

  useEffect(() => {
    if (!currentNotification?.timeoutSec) return;

    const timer = setTimeout(() => close(currentNotification), currentNotification.timeoutSec * 1000);
    return () => clearTimeout(timer);
  }, [close, currentNotification]);

  if (!currentNotification) return null;

  return (
    <Notification
      key={currentNotification.message}
      message={currentNotification.message}
      close={() => close(currentNotification)}
      severity={currentNotification.severity}
    />
  );
}
